import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateOrUpdateAuftraggeberMutation, useDeleteAuftraggeberMutation, useGetAuftraggeberMutation, useGetRechnungsempfaengerListeMutation } from '../../../api/StammdatenAPI';
import { IAuftraggeber, IAuftraggeberRequest, IRechnungsempfaenger } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';

const emptyIAuftraggeberDto: IAuftraggeberRequest = {
  uid: '',
  name: '',
  uid_rechnungsempfaenger: null
}

export default function AuftraggeberDetail() {
  const { t } = useTranslation();

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const [daten, setDaten] = useState<IAuftraggeberRequest>(emptyIAuftraggeberDto);

  const [moegRechnungsempfaenger, setMoegRechnungsempfaenger] = useState<IRechnungsempfaenger[]>();
  const [getRechnungsempfaengerApi] = useGetRechnungsempfaengerListeMutation();

  const [getAuftraggeberAPI] = useGetAuftraggeberMutation();

  const [deleteAuftraggeberAPI] = useDeleteAuftraggeberMutation();
  const [createOrUpdateAuftraggeberAPI] = useCreateOrUpdateAuftraggeberMutation();

  const navigate = useNavigate();
  const location = useLocation();

  const init = () => {

    getRechnungsempfaengerApi().unwrap()
      .then(data => setMoegRechnungsempfaenger(data))
      .catch((e) => console.log(e));

    if (location.state.view === 'detail') {
      getAuftraggeberAPI(location.state.id)
        .unwrap()
        .then((e) => {
          setDaten({
            uid: e.uid,
            name: e.name,
            uid_rechnungsempfaenger: e.rechnungsempfaenger ? e.rechnungsempfaenger.uid : null
          });
          setLoaded(true);
        })
        .catch((ee) => console.log(ee))

    } else if (location.state.view === 'create') {
      setDaten(emptyIAuftraggeberDto)
      setLoaded(true);
    }
  }

  const handleDelete = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();
    if (window.confirm('Sind sie sicher den Datensatz löschen zu wollen?')) {
      deleteAuftraggeberAPI(daten!.uid).unwrap()
        .then(() => navigate('/admin/auftraggeber/'))
        .catch((ee) => console.log(ee))
    }
  }

  const handleSubmit = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    if (location.state.view === 'detail' || location.state.view === 'create') {

      if (location.state.view === 'detail') {

        createOrUpdateAuftraggeberAPI(daten)
          .then(() => navigate('/admin/auftraggeber/'))
          .catch((ee) => console.log(ee))
      }

      if (location.state.view === 'create') {

        createOrUpdateAuftraggeberAPI(daten)
          .then(() => navigate('/admin/auftraggeber/'))
          .catch((ee) => console.log(ee))
      }

    }
  }

  const changeit = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const changeitselect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDaten((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate("../", {
                relative: "path"
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>


          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Auftraggeber Detail</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>

          <form onSubmit={handleSubmit} className={styles["wg-detail-form"]} >
            {(isLoaded && daten !== undefined &&
              <>
                <div className={styles['wg-detail-form-ueb']}>
                  <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>{daten?.uid}</span></div>
                  <div style={{ textAlign: "end" }}>{(location.state.view === 'detail' && <button type="button" className={styles["wg-a"]} onClick={handleDelete}><i className="bi bi-trash"></i></button>)}</div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Name</label>
                    <input type="text" className={styles['wg-input-text']} name="name" value={daten?.name} onChange={changeit} />
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div>
                    <label className={styles['wg']}>Rechnungsempfänger</label>
                    <select name="uid_rechnungsempfaenger" className={styles['wg-input-select']} onChange={changeitselect} value={"" + daten.uid_rechnungsempfaenger}>
                      <option value={""}>-- Bitte auswählen --</option>
                      {moegRechnungsempfaenger?.map((e, index) =>
                        <option key={index} value={e.uid} selected={daten.uid_rechnungsempfaenger === e.uid ? true : false}>{e.name1}</option>)
                      }
                    </select>
                  </div>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles["wg-detail-grid-2"]}>
                  <div></div>
                  <div></div>
                  <div style={{ textAlign: "end" }}><input type="submit" value="Speichern" className={styles['wg-btn']} /></div>
                </div>

          </>)}
        </form>


      </div>
    </div >
    </>
  );
}